<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      resizable
      auto-resize
      show-footer-overflow
      cell-class-name="align-top"
      :columns="tableColumns"
      :loading="loading"
      :data="tableData"
      :max-height="tableHeight - 200"
    >
      <template v-slot:displayScm="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item :label="'NC'">
            {{ row.ncNo }}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item>
            {{ row.scmName }}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item>
            {{ row.displayEcomWarehouseName }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:displayFactory="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item
            :label="$l('table_label_invoiceFactory') || '开票'"
          >
            {{ row.invoiceFactoryName }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_shippingFactory') || '送货'"
          >
            {{ row.shippingFactoryName }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_factoryDate') || '产装'"
          >
            {{ row.factoryDate }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:displayOrder="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item
            :label="$l('table_label_amzPurchaseNo') || '订单号'"
          >
            {{ row.poNo }}
          </el-descriptions-item>
          <el-descriptions-item :label="$l('table_label_ftyPrice') || '采购价'">
            {{ row.ftyPrice }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:displayCtnQty="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item :label="$l('table_label_ctnQty') || '整箱'">
            {{ row.ctnQty }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_tailCtnQty') || '尾箱'"
            v-if="row.tailCtnQty"
            :contentStyle="{ color: 'red' }"
          >
            {{ row.tailCtnQty }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_totalCtnQty') || '总箱'"
            v-if="row.totalCtnQty"
          >
            {{ row.totalCtnQty }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .col--edit .vxe-cell {
    padding: 7px 0;
  }
  .vxe-body--column.displayFactory:not(.col--actived) .vxe-cell,
  .vxe-body--column.replyQty:not(.col--actived) .vxe-cell {
    padding-top: 0;
    padding-bottom: 0;
  }
  .col--seq:not(.vxe-header--column) .vxe-cell {
    margin-top: 7px;
    padding-left: 4px;
    padding-right: 4px;
  }

  .vxe-body--column:not(.col--edit) {
    .el-descriptions-item__container {
      line-height: 27px;
      .el-descriptions-item__label:empty {
        display: none;
      }
      .el-descriptions-item__content {
        flex: 1;
      }
      .el-descriptions-item__label:not(.is-bordered-label) {
        margin-right: 5px;
      }
    }
  }

  .el-descriptions-item__container {
    line-height: 27px;
    .el-descriptions-item__label:empty {
      display: none;
    }
    .el-descriptions-item__content {
      flex: 1;
    }
    .el-descriptions-item__label:not(.is-bordered-label) {
      margin-right: 5px;
    }
  }

  .vxe-body--column:not(.col--edit) {
    .el-descriptions-item__container {
      line-height: 1.5;
    }
  }
}
</style>
